import { render } from "./EstimateCalculator.vue?vue&type=template&id=70de21cc&scoped=true&ts=true"
import script from "./EstimateCalculator.vue?vue&type=script&lang=ts"
export * from "./EstimateCalculator.vue?vue&type=script&lang=ts"

import "./EstimateCalculator.vue?vue&type=style&index=0&id=70de21cc&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70de21cc"]])

export default __exports__